export default class LegalRepresentative {
  /** GL */
  relType: string
  /** AltamiraId */
  relSequence: number
  /** Όνομα */
  firstName: string
  /** Επώνυμο */
  lastName: string
  /** Πατρώνυμο */
  fatherName: string
  /** ΑΦΜ */
  afm: string

  fullName: string
  isFromAltamira: boolean
  specialAttributeIds: Array<number>
}
